import React from 'react'

import { LAST_VIEW_KEY } from './constants'

export function useUnreadPosts(latestPostPublishedTimeSec: number) {
    const [hasUnreadPosts, setHasUnreadPosts] = React.useState(false)

    React.useEffect(
        function detectUnreadPosts() {
            const lastViewTime = localStorage.getItem(LAST_VIEW_KEY)

            if (Number(lastViewTime) < latestPostPublishedTimeSec) {
                setHasUnreadPosts(true)
            }
        },
        [latestPostPublishedTimeSec]
    )

    return hasUnreadPosts
}
